import { makeStyles } from "@material-ui/core";
import { useReducer } from "react";
import { ManufacturerRegister } from './Manufacturer';
import CustomTabStyle from "../../componentes/tabs/CustomTabStyle";
import CustomTabs from "../../componentes/tabs/CustomTabs";
import CallOutlinedIcon from "@material-ui/icons/CallOutlined";
import MailOutlineIcon from "@material-ui/icons/MailOutlineOutlined";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import SearchIcon from "@material-ui/icons/Search";
import { useTranslation } from "react-i18next";
import a11yProps from "../../componentes/tabs/a11Props";
import TabPanel from "../../componentes/tabs/TabPanel";
import FormContainer from "../../componentes/form-container/FormContainer";
import { ManufacturerAddress } from "./ManufacturerAddress";

/**
 * Author : AndréK
 * 26/08/2022
*/
const useStyles = makeStyles((theme) => ({
    root: {
        marginRight: 10,
    },
}));

const reducer = (state, data) => {
    return { ...state, ...data }
}

const initialState = {
    id: 0,
    tabValue: 0,
};

const ManufacturerControl = () => {

    const { t } = useTranslation();
    const classes = useStyles();
    const [state, dispatch] = useReducer(reducer, initialState);
    const { id, tabValue } = state
    const handleTabChange = (event, newValue) => dispatch({ tabValue: newValue });

    return (
        <>
            <FormContainer>
                <CustomTabs
                    value={tabValue}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="manufacturer tab"
                >
                    <CustomTabStyle
                        label={t("manufacturer")}
                        {...a11yProps(0)}
                        icon={<SearchIcon fontSize="small" classes={classes} />} />
                    <CustomTabStyle
                        label={t("address")}
                        {...a11yProps(1)}
                        disabled={id === 0}
                        icon={<HomeOutlinedIcon fontSize="small" classes={classes} />} />
                </CustomTabs>
                <TabPanel value={tabValue} index={0}>
                    <ManufacturerRegister updateId={dispatch} />
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    <ManufacturerAddress idManufacturer={id} />
                </TabPanel>
            </FormContainer>
        </>
    )
}

export default ManufacturerControl;